module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/319.480430bb.png";